import * as options from './options';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Properties from './Properties';
import SelectorList from './SelectorList';

export default class StyleRule extends Layer       {
	
	get [Symbol.toStringTag] () { return 'StyleRule'; }
	
	         selector = TOKEN.currentLayer ? TOKEN.collection_selector[TOKEN.collection_selector.length] = new SelectorList(this) : new SelectorList(this);
	         block = new Properties(this);
	
	constructor () { return super()                   ; }
	
	[TOKEN.consume] (               ) {
		TOKEN.stay();
		return this.selector;
	}
	
	[Symbol.toPrimitive] (               ) {
		return this.block.length ? `${this.selector}{${( '' + this.block ).slice(0, -1)}}` : '';
	}
	
	* [Symbol.iterator] (               )                                {
		const { block, selector } = this;
		const { length } = block;
		if ( length && selector.length ) {
			let index = 0;
			let selectorText        ;
			if ( options.newlineSelector ) {
				const lastIndex = selector.length - 1;
				let index = 0;
				while ( index!==lastIndex ) {
					yield selector[index++] + ',';
				}
				selectorText = '' + selector[lastIndex];
			}
			else { selectorText = selector.join(', '); }
			if ( options.newlineProperty ) {
				yield `${selectorText} {`;
				while ( index!==length ) {
					for ( const line of block[index++]  ) {
						yield options.indent + line;
					}
				}
				yield `}`;
			}
			else {
				let cssText = ' ';
				while ( index!==length ) {
					for ( const line of block[index++]  ) {
						cssText += line + ' ';
					}
				}
				yield `${selectorText} {${cssText}}`;
			}
		}
	}
	
	                                       
	
	static default = protect(this);
	
};

                              
                                 